// extracted by mini-css-extract-plugin
module.exports = {"self":"Countdown_self__9avWk"};